// extracted by mini-css-extract-plugin
module.exports = {"container":"Write_container__2rPO2","itemA":"Write_itemA__2Pleb","itemB":"Write_itemB__3NNGl","itemC":"Write_itemC__3pMjQ","itemD":"Write_itemD__3dH2k"};